// Queries
import receiptLog from "./ReceiptLogQuery.gql";

export const Query = {
    receiptLog,
};
